export default __webpack_public_path__ + "static/media/elevator.5399c3f3.svg";